export const PART_LOAD_MIN_LDM = 3;
